import { Component, OnInit } from '@angular/core';
import { LanguageService } from 'src/app/services/language.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  test : Date = new Date();
  
  constructor(private languageService: LanguageService) { }

  changeLang(lang: string) {
    this.languageService.setLanguage(lang); // Will update app language dynamically
  }

  ngOnInit() {
  }
  activeId: number | null = null;

  socialMedia = [
    {
      id: 1,
      title: 'Facebook',
      iconClass: 'icon-logo-facebook',
      links: [
        { label: 'Daimler Truck Career', url: 'https://www.facebook.com/daimlertruckcareer' },
        { label: 'Mercedes-Benz Trucks', url: 'https://www.facebook.com/mercedesbenztrucksglobal/' },
        { label: 'Freightliner', url: 'https://www.facebook.com/freightliner' }
      ]
    },
    {
      id: 2,
      title: 'X (Twitter)',
      iconClass: 'icon-logo-twitter-x',
      links: [
        { label: '@DaimlerTruck', url: 'https://twitter.com/DaimlerTruck' },
        { label: 'Freightliner', url: 'https://twitter.com/freightliner' }
      ]
    },
    {
      id: 3,
      title: 'YouTube',
      iconClass: 'icon-logo-youtube',
      links: [
        { label: 'Daimler Truck AG', url: 'https://www.youtube.com/@DaimlerTruck_AG' }
      ]
    }
  ];

  togglePopup(id: number): void {
    this.activeId = this.activeId === id ? null : id;
  }

  scrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

  closePopup(): void {
    this.activeId = null;
  }
  isOpen = false;

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }
  openId: number | null = null;

  toggle(id: number) {
    this.openId = this.openId === id ? null : id;
  }
}
